import { DeviceDto } from "@/api/query.schemas";
import { MIN_CORE_CHARGER_LOGS_SEMVER } from "@/constants";
import { gte, valid } from "semver";

export const isCoreChargerLogsDevice = (device?: DeviceDto) => {
    if (device?.deviceType !== "Core" || !device.fwVersion) return false;
    const fwVersion = valid(device.fwVersion);
    return !!fwVersion && gte(fwVersion, MIN_CORE_CHARGER_LOGS_SEMVER);
};
